export const creditsTranslations = {
  en: {
    pageTitle: 'Credits & Usage',
    pageSubtitle: 'Manage your credit balance, view detailed usage history, or purchase additional credits.',
    
    // Current Credits Card
    currentCredits: 'Current Available Credits',
    credits: 'Credits',
    monthlyUsage: 'Monthly quota used',
    
    // Purchase Packs Section
    purchaseTitle: 'Purchase Extra Credit Packs',
    microPack: 'Micro Pack',
    proPack: 'Pro Pack',
    maxPack: 'Max Pack',
    bestValue: 'BEST VALUE',
    instantDelivery: 'Instant delivery',
    
    // Custom Pack
    customPack: 'Custom',
    customPlaceholder: 'Custom',
    customRate: '1 USD = 1,000 Credits',
    minPurchaseError: 'Minimum purchase {amount} credits',
    pleaseLogin: 'Please login first',
    paymentLinkError: 'Failed to get payment link',
    createSessionError: 'Failed to create payment session',
    processing: 'Processing...',
    
    // Transaction Table
    transactionTitle: 'Usage Details',
    noTransactions: 'No transaction records',
    tableHeaderAction: 'Action',
    tableHeaderTime: 'Time',
    tableHeaderCredits: 'Credits Change',
    tableHeaderStatus: 'Status',
    
    // Transaction Status
    statusSuccess: 'Success',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    
    // Pagination
    showing: 'Showing {start} - {end} of {total} records',
    previousPage: 'Previous',
    nextPage: 'Next',
    
    // Loading & Error
    loading: 'Loading credits and usage...',
    loadError: 'Failed to load, please try again',
    retry: 'Retry',
  },
  ja: {
    pageTitle: 'クレジットと利用状況',
    pageSubtitle: 'クレジット残高の管理、詳細な利用履歴の確認、追加クレジットの購入ができます。',
    
    // Current Credits Card
    currentCredits: '現在の利用可能クレジット',
    credits: 'クレジット',
    monthlyUsage: '今月の使用率',
    
    // Purchase Packs Section
    purchaseTitle: '追加クレジットパックを購入',
    microPack: 'マイクロパック',
    proPack: 'プロパック',
    maxPack: 'マックスパック',
    bestValue: 'おすすめ',
    instantDelivery: '即時反映',
    
    // Custom Pack
    customPack: 'カスタム',
    customPlaceholder: 'カスタム',
    customRate: '1 USD = 1,000 クレジット',
    minPurchaseError: '最低購入は {amount} クレジットです',
    pleaseLogin: 'まずログインしてください',
    paymentLinkError: '決済リンクの取得に失敗しました',
    createSessionError: '決済セッションの作成に失敗しました',
    processing: '処理中...',
    
    // Transaction Table
    transactionTitle: '利用明細',
    noTransactions: '取引履歴はありません',
    tableHeaderAction: '操作',
    tableHeaderTime: '時間',
    tableHeaderCredits: 'クレジット変動',
    tableHeaderStatus: 'ステータス',
    
    // Transaction Status
    statusSuccess: '成功',
    statusCompleted: '完了',
    statusPending: '保留中',
    statusFailed: '失敗',
    
    // Pagination
    showing: '全 {total} 件中 {start} - {end} 件を表示',
    previousPage: '前へ',
    nextPage: '次へ',
    
    // Loading & Error
    loading: 'クレジットと利用状況を読み込み中...',
    loadError: '読み込みに失敗しました。もう一度お試しください',
    retry: '再試行',
  },
  
  "zh-CN": {
    pageTitle: '积分与算力消耗',
    pageSubtitle: '管理您的算力积分余额，查看详细的使用记录或购买额外积分。',
    
    // Current Credits Card
    currentCredits: '当前可用积分',
    credits: 'Credits',
    monthlyUsage: '本月额度已使用',
    
    // Purchase Packs Section
    purchaseTitle: '购买额外积分包',
    microPack: '体验包',
    proPack: '标准包',
    maxPack: '超大包',
    bestValue: 'BEST VALUE',
    instantDelivery: '立即到账',
    
    // Custom Pack
    customPack: '自定义',
    customPlaceholder: '自定义',
    customRate: '1 USD = 1,000 积分',
    minPurchaseError: '最少购买 {amount} 积分',
    pleaseLogin: '请先登录',
    paymentLinkError: '未获取到支付链接',
    createSessionError: '创建支付会话失败',
    processing: '处理中...',
    
    // Transaction Table
    transactionTitle: '算力消耗明细',
    noTransactions: '暂无交易记录',
    tableHeaderAction: '操作项目',
    tableHeaderTime: '时间',
    tableHeaderCredits: '积分变动',
    tableHeaderStatus: '状态',
    
    // Transaction Status
    statusSuccess: 'Success',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    
    // Pagination
    showing: '显示 {start} - {end} 条，共 {total} 条记录',
    previousPage: '上一页',
    nextPage: '下一页',
    
    // Loading & Error
    loading: '加载积分与算力...',
    loadError: '加载失败，请重试',
    retry: '重试',
  },
  
  "zh-TW": {
    pageTitle: '積分與算力消耗',
    pageSubtitle: '管理您的算力積分餘額，查看詳細的使用記錄或購買額外積分。',
    
    // Current Credits Card
    currentCredits: '當前可用積分',
    credits: 'Credits',
    monthlyUsage: '本月額度已使用',
    
    // Purchase Packs Section
    purchaseTitle: '購買額外積分包',
    microPack: '體驗包',
    proPack: '標準包',
    maxPack: '超大包',
    bestValue: 'BEST VALUE',
    instantDelivery: '立即到賬',
    
    // Custom Pack
    customPack: '自定義',
    customPlaceholder: '自定義',
    customRate: '1 USD = 1,000 積分',
    minPurchaseError: '最少購買 {amount} 積分',
    pleaseLogin: '請先登入',
    paymentLinkError: '未獲取到支付鏈接',
    createSessionError: '創建支付會話失敗',
    processing: '處理中...',
    
    // Transaction Table
    transactionTitle: '算力消耗明細',
    noTransactions: '暫無交易記錄',
    tableHeaderAction: '操作項目',
    tableHeaderTime: '時間',
    tableHeaderCredits: '積分變動',
    tableHeaderStatus: '狀態',
    
    // Transaction Status
    statusSuccess: 'Success',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    
    // Pagination
    showing: '顯示 {start} - {end} 條，共 {total} 條記錄',
    previousPage: '上一頁',
    nextPage: '下一頁',
    
    // Loading & Error
    loading: '加載積分與算力...',
    loadError: '加載失敗，請重試',
    retry: '重試',
  },
  
  es: {
    pageTitle: 'Créditos y Uso',
    pageSubtitle: 'Administra tu saldo de créditos, consulta el historial de uso detallado o compra créditos adicionales.',
    
    // Current Credits Card
    currentCredits: 'Créditos Disponibles Actuales',
    credits: 'Créditos',
    monthlyUsage: 'Cuota mensual utilizada',
    
    // Purchase Packs Section
    purchaseTitle: 'Comprar Paquetes de Créditos Extra',
    microPack: 'Paquete Micro',
    proPack: 'Paquete Pro',
    maxPack: 'Paquete Max',
    bestValue: 'MEJOR VALOR',
    instantDelivery: 'Entrega instantánea',
    
    // Custom Pack
    customPack: 'Personalizado',
    customPlaceholder: 'Personalizado',
    customRate: '1 USD = 1,000 Créditos',
    minPurchaseError: 'Compra mínima {amount} créditos',
    pleaseLogin: 'Por favor inicia sesión primero',
    paymentLinkError: 'No se pudo obtener el enlace de pago',
    createSessionError: 'Error al crear sesión de pago',
    processing: 'Procesando...',
    
    // Transaction Table
    transactionTitle: 'Detalles de Uso',
    noTransactions: 'No hay registros de transacciones',
    tableHeaderAction: 'Acción',
    tableHeaderTime: 'Hora',
    tableHeaderCredits: 'Cambio de Créditos',
    tableHeaderStatus: 'Estado',
    
    // Transaction Status
    statusSuccess: 'Éxito',
    statusCompleted: 'Completado',
    statusPending: 'Pendiente',
    statusFailed: 'Fallido',
    
    // Pagination
    showing: 'Mostrando {start} - {end} de {total} registros',
    previousPage: 'Anterior',
    nextPage: 'Siguiente',
    
    // Loading & Error
    loading: 'Cargando créditos y uso...',
    loadError: 'Error al cargar, por favor intenta de nuevo',
    retry: 'Reintentar',
  },
};
